package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveCombat
import fr.manyverse.app.domain.repository.CombatRepository

/**
 * Passe au participant suivant (le tour boucle sur le premier après le dernier).
 */
class CombatNextTurnUseCase(
    private val combatRepository: CombatRepository
) {
    suspend operator fun invoke(combat: ActiveCombat): Result<Unit> {
        if (combat.participants.isEmpty()) return Result.success(Unit)
        val nextIndex = (combat.activeIndex + 1) % combat.participants.size
        return combatRepository.updateActiveIndex(combat.id, nextIndex)
    }
}
